import { useParams } from 'react-router-dom';



export const tabs = [
  {
    id: 'preAlertAcknowledged',
    label: "Incoming RMAs",
    requiredPermissions: []
  },
  {
    id: 'awaitingTriageObservation',
    label: "Awaiting Triage Observation",
    requiredPermissions: []
  },
  {
    id: 'awaitingReturnDecision',
    label: "Awaiting Return Decision",
    requiredPermissions: []
  },
  {
    id: 'qualityControl',
    label: "Awaiting QC",
    requiredPermissions: []
  },
  {
    id: 'printLabel',
    label: "Print Label",
    requiredPermissions: []
  }
] as const;

export type ITabId = typeof tabs[number]['id'];



export function useReturnAuthorizationActivityParams() {
  return useParams<{ tabId: ITabId; }>();
}
